import { Injectable } from "@angular/core";
import {
	ActivatedRouteSnapshot,
	CanActivate,
	CanActivateChild,
	GuardResult,
	MaybeAsync,
	Router,
	RouterStateSnapshot,
} from "@angular/router";
import { UserSettingsQuery } from "@timeghost/web-api";

@Injectable({
	providedIn: "root",
})
export class ReportsPageGuard implements CanActivate, CanActivateChild {
	constructor(
		private userSettingsQuery: UserSettingsQuery,
		private router: Router
	) {}
	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): MaybeAsync<GuardResult> {
		const user = this.userSettingsQuery.getValue();
		if (user.workspace?.settings["projecthoursEnabled"] || /^\/dashboard\/(contingent|schedules)/.test(state.url))
			return true;
		const navigation = this.router.getCurrentNavigation();
		return (
			(navigation.previousNavigation && navigation.previousNavigation.initialUrl) ||
			this.router.createUrlTree(["/timer"])
		);
	}
	canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): MaybeAsync<GuardResult> {
		return this.canActivate(childRoute, state);
	}
}
